import { render, staticRenderFns } from "./GroupPerformanceChart.vue?vue&type=template&id=af8f9aec&scoped=true"
import script from "./GroupPerformanceChart.vue?vue&type=script&lang=js"
export * from "./GroupPerformanceChart.vue?vue&type=script&lang=js"
import style0 from "./GroupPerformanceChart.vue?vue&type=style&index=0&id=af8f9aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8f9aec",
  null
  
)

export default component.exports